import React, { useRef, useState } from "react"
import {
	Grid,
	Typography,
	CircularProgress
} from "@material-ui/core"
import { themeColors } from "letalkui"

import { AIIcon } from "@/assets/icons"

import { SvgIcon } from "@/components"

import useStyles from "@/pages/Admin/MeetingAnalyzer/CreateDialog/LoadingContent/styles"
import useDidMount from "@/hooks/useDidMount"
import useUnmount from "@/hooks/useUnmount"

const CYCLIC_MESSAGE_INTERVAL_IN_MILLISECONDS = 2500

const CYCLIC_LOADING_MESSAGES = [
	"Identificando fases da reunião...",
	"Analisando perfil do closer...",
	"Calculando score por tópico...",
	"Gerando oportunidades de melhoria..."
]

const LoadingContent: React.FC = () => {
	const classes = useStyles()

	const [cyclicMessageIndex, setCyclicMessageIndex] = useState(0)
	const loadingMessage = CYCLIC_LOADING_MESSAGES[cyclicMessageIndex]

	const cyclicIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null)

	useDidMount(() => {
		cyclicIntervalRef.current = setInterval(() => {
			setCyclicMessageIndex(prevIndex => (prevIndex + 1) % CYCLIC_LOADING_MESSAGES.length)
		}, CYCLIC_MESSAGE_INTERVAL_IN_MILLISECONDS)
	})

	useUnmount(() => {
		if (cyclicIntervalRef.current) {
			clearInterval(cyclicIntervalRef.current)
			cyclicIntervalRef.current = null
		}
	})

	return (
		<Grid container direction="column" alignItems="center" className={classes.loadingContainer}>
			<Grid item>
				<div className={classes.spinnerContainer}>
					<CircularProgress
						size={100}
						thickness={2}
						style={{ color: themeColors.colors.system.purple[300], position: "absolute" }}
					/>
					<SvgIcon
						icon={AIIcon}
						fontSize="large"
						color="primary"
						autoSize
					/>
				</div>
			</Grid>
			<Grid item>
				<Typography className={classes.loadingTitle}>
					Analisando reunião
				</Typography>
			</Grid>
			<Grid item>
				<Typography className={classes.loadingSubtitle}>
					Nossa IA está revisando a transcrição em busca de padrões, oportunidades e próximos passos.
				</Typography>
			</Grid>
			<Grid item>
				<Typography className={classes.loadingMessage}>
					{loadingMessage}
				</Typography>
			</Grid>
		</Grid>
	)
}

export default LoadingContent
